import { IApplicationState } from '../../types/redux';

export const selectTooltipTarget = (state: IApplicationState) => {
  return state.filters.tooltipTarget;
};
